import { paginationReducer as pagination } from '../../../features/pagination/pagination-slice.js';
import { searchReducer as search } from '../../../features/search/search-slice.js';
import { loadReducerError } from '../../../utils/errors.js';
import { buildController, } from '../../controller/headless-controller.js';
import { buildCoreStatus, } from '../status/headless-core-status.js';
/**
 * Creates a `QuerySummary` controller instance.
 *
 * @param engine - The headless engine instance.
 * @returns A `QuerySummary` controller instance.
 */
export function buildCoreQuerySummary(engine) {
    if (!loadQuerySummaryReducers(engine)) {
        throw loadReducerError;
    }
    const controller = buildController(engine);
    const searchStatus = buildCoreStatus(engine);
    const getState = () => engine.state;
    const durationInSeconds = () => {
        const inSeconds = getState().search.duration / 1000;
        return Math.round((inSeconds + Number.EPSILON) * 100) / 100;
    };
    return {
        ...controller,
        get state() {
            return {
                ...searchStatus.state,
                durationInMilliseconds: getState().search.duration,
                durationInSeconds: durationInSeconds(),
                firstResult: getState().pagination.firstResult + 1,
                hasDuration: getState().search.duration !== 0,
                hasQuery: getState().search.queryExecuted !== '',
                lastResult: getState().pagination.firstResult + getState().search.results.length,
                query: getState().search.queryExecuted,
                total: getState().pagination.totalCountFiltered,
            };
        },
    };
}
function loadQuerySummaryReducers(engine) {
    engine.addReducers({ search, pagination });
    return true;
}
